export enum DriverPaymentMode {
    MONTHLY = 'monthly',
    PERCENTAGE = 'percentage',
}